__turbopack_context__.v({
  "navigationListItem": "hOAP-q_navigationListItem",
  "navigationListItem--lgDown": "hOAP-q_navigationListItem--lgDown",
  "navigationListItem--lgUp": "hOAP-q_navigationListItem--lgUp",
  "navigationListItem--mdUp": "hOAP-q_navigationListItem--mdUp",
  "navigationListItem--smUp": "hOAP-q_navigationListItem--smUp",
  "navigationListItem--xlUp": "hOAP-q_navigationListItem--xlUp",
});
